const pad = (n) => String(n).padStart(2, "0");

const endOf = (date, time, minutes) => {
  const [h, m] = time.split(":").map(Number);
  const total = h * 60 + m + (Number(minutes) || 45);
  const d = new Date(`${date}T00:00:00`);
  d.setDate(d.getDate() + Math.floor(total / 1440));
  const rest = total % 1440;
  return { date: `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`, time: `${pad(Math.floor(rest / 60))}:${pad(rest % 60)}` };
};

const stamp = (date, time) => `${date.replaceAll("-", "")}T${time.replace(":", "")}00`;
const esc = (s) => String(s || "").replace(/\\/g, "\\\\").replace(/\n/g, "\\n").replace(/([,;])/g, "\\$1");

const details = (a) => {
  const s = a.studio;
  const location = s ? [s.name, s.address, [s.cap, s.city].filter(Boolean).join(" ")].filter(Boolean).join(", ") : a.location || "";
  const lines = [a.reason || "Visita", "Dott.ssa Simona Marretta – Biologa Nutrizionista"];
  if (s?.phone) lines.push(`Tel. ${s.phone}`);
  if (s?.directions) lines.push(s.directions);
  if (s?.maps_link) lines.push(`Mappa: ${s.maps_link}`);
  return { title: `Visita nutrizionista – Dott.ssa Marretta`, location, description: lines.join("\n") };
};

const VTIMEZONE = [
  "BEGIN:VTIMEZONE", "TZID:Europe/Rome",
  "BEGIN:DAYLIGHT", "TZOFFSETFROM:+0100", "TZOFFSETTO:+0200", "TZNAME:CEST", "DTSTART:19700329T020000", "RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU", "END:DAYLIGHT",
  "BEGIN:STANDARD", "TZOFFSETFROM:+0200", "TZOFFSETTO:+0100", "TZNAME:CET", "DTSTART:19701025T030000", "RRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU", "END:STANDARD",
  "END:VTIMEZONE",
];

export function downloadIcs(a) {
  const { title, location, description } = details(a);
  const end = endOf(a.date, a.time, a.duration);
  const now = new Date();
  const dtstamp = `${now.getUTCFullYear()}${pad(now.getUTCMonth() + 1)}${pad(now.getUTCDate())}T${pad(now.getUTCHours())}${pad(now.getUTCMinutes())}00Z`;
  const ics = [
    "BEGIN:VCALENDAR", "VERSION:2.0", "PRODID:-//Studio Nutrizionista Simona Marretta//IT", "CALSCALE:GREGORIAN", "METHOD:PUBLISH",
    ...VTIMEZONE,
    "BEGIN:VEVENT", `UID:${a.id}@nutrizionistasimonamarretta`, `DTSTAMP:${dtstamp}`,
    `DTSTART;TZID=Europe/Rome:${stamp(a.date, a.time)}`, `DTEND;TZID=Europe/Rome:${stamp(end.date, end.time)}`,
    `SUMMARY:${esc(title)}`, `LOCATION:${esc(location)}`, `DESCRIPTION:${esc(description)}`,
    "BEGIN:VALARM", "TRIGGER:-PT2H", "ACTION:DISPLAY", `DESCRIPTION:${esc(title)}`, "END:VALARM",
    "END:VEVENT", "END:VCALENDAR",
  ].join("\r\n");
  const url = URL.createObjectURL(new Blob([ics], { type: "text/calendar;charset=utf-8" }));
  const link = document.createElement("a");
  link.href = url;
  link.download = `appuntamento-${a.date}.ics`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  setTimeout(() => URL.revokeObjectURL(url), 10000);
}

export function googleCalendarUrl(a) {
  const { title, location, description } = details(a);
  const end = endOf(a.date, a.time, a.duration);
  const p = new URLSearchParams({ action: "TEMPLATE", text: title, dates: `${stamp(a.date, a.time)}/${stamp(end.date, end.time)}`,
    ctz: "Europe/Rome", location, details: description });
  return `https://calendar.google.com/calendar/render?${p.toString()}`;
}
